import React from 'react';
import styled from 'styled-components';
import { renderTaggedPrintNotes } from '@mummssoftware/common-ui';
import defaults from '../../translations/en.json';

const MainNoteDiv = styled.div`
  padding-left: 40px;
  margin-top: 15px;
  width: 95%;
  font-size: 14px;
  @media print {
    color: ${(props) => props.theme.palette.common.black};
  }
`;

type PrintNoteProps = {
  bereavementNotes: any[];
  careGiversInfo: any[];
};

export const PrintNotes = ({
  bereavementNotes,
  careGiversInfo,
}: PrintNoteProps) => {
  const CGById = careGiversInfo.reduce((seed, CG) => {
    const id: any = CG.id && CG.id;
    if (id) {
      seed[id] = CG;
    }
    return seed;
  }, {} as Record<number, any>);
  const keys: any[] = bereavementNotes && Object.keys(bereavementNotes);

  return keys && keys.length ? (
    <MainNoteDiv>
      {keys.map((key) => {
        const CG = CGById[key];
        let title;
        if (CG) {
          const {
            caregiverfirstname,
            caregiverlastname,
            caregivertitle,
            caregiverrelationship,
          } = CG;
          title = `${defaults?.notesRelatedTo}${
            ` ${caregivertitle}` || ''
          } ${caregiverfirstname} ${caregiverlastname} - ${caregiverrelationship}`;
        } else {
          title = defaults?.relatedNotes;
        }
        return (
          title && renderTaggedPrintNotes((bereavementNotes as any)[key], title)
        );
      })}
    </MainNoteDiv>
  ) : null;
};
